<template>

  <main class="competition-page">

    <!--    <CompetitionHeader :competition="competition"/>-->
    <CompetitionSwitcher/>
    <div class="top-table">
      <CompetitionTabs v-model="activeTab"/>
      <SeasonSwitcher :competitionId="competition.id" :initialSeasonId="currentSeasonId"
                      @season-change="onSeasonChange"/>
    </div>
    <div v-if="activeTab==='table' && tableGroups.length > 1" class="table-group-switch">
      <button
          v-for="g in tableGroups"
          :key="g.name"
          class="group-chip"
          :class="{ active: g.name === activeGroup }"
          @click="selectGroup(g.name)"
      >{{ g.name }}</button>
    </div>
    <CompetitionTable v-if="activeTab==='table'" :rows="table"/>
    <CompetitionMatches v-if="activeTab==='matches'" :matches="matches"/>
    <CompetitionNews v-if="activeTab==='news'" :news="news"/>
    <CompetitionStats v-if="activeTab==='stats'" :rows="table" :matches="matches" :competition-id="competition ? competition.id : null"/>
  </main>

</template>

<script>
import CompetitionSwitcher from '@/components/competition/CompetitionSwitcher.vue'
// import CompetitionHeader from '@/components/competition/CompetitionHeader.vue'
import CompetitionTabs from '@/components/competition/CompetitionTabs.vue'
import CompetitionTable from '@/components/competition/CompetitionTable.vue'
import CompetitionMatches from '@/components/competition/CompetitionMatches.vue'
import CompetitionNews from '@/components/competition/CompetitionNews.vue'
import CompetitionStats from '@/components/competition/CompetitionStats.vue'
import SeasonSwitcher from "@/components/competition/seasonSwitcher.vue";
import competitionService from '@/services/competition.service'
import api from '@/services/api'
import { setSeo } from '@/utils/seo'

export default {

  name: 'Competition',

  components: {
    SeasonSwitcher,
    // CompetitionHeader,
    CompetitionSwitcher,
    CompetitionTabs,
    CompetitionTable,
    CompetitionStats,
    CompetitionNews,
    CompetitionMatches

  },

  data() {

    return {

      competition: null,
      activeTab: 'table',
      table: [],
      tableGroups: [],
      activeGroup: null,
      matches: [],
      news: [],
      matchesLoaded: false,
      newsLoaded: false,
      currentSeasonId: null
    }

  },

  async created() {

    await this.loadCompetition()

  },
  watch: {

    '$route.params.id'() {

      this.loadCompetition()

    },

    // لود تنبل دادهٔ هر تب — فقط وقتی اولین بار باز می‌شود
    activeTab(tab) {

      this.ensureTabData(tab)

    }

  },
  methods: {
    async loadCompetition() {
      const id = this.$route.params.id;
      try {
        const allCompetitions = this.$store.getters.competitions || [];
        this.competition = allCompetitions.filter(c => c.id == id)[0];
        if (this.competition && this.competition.name) {
          setSeo({
            title: `${this.competition.name} | جدول، برنامه و نتایج | ضربه آزاد`,
            description: `${this.competition.name} — جدول رده‌بندی، برنامه بازی‌ها و آخرین نتایج در ضربه آزاد`,
            image: this.competition.logo || null,
            path: `/competition/${id}`,
          });
        } else if (allCompetitions.length) {
          // لیست لیگ‌ها لود شده و این id در آن نیست → واقعاً ناموجود است
          setSeo({ notFound: true, title: 'لیگ پیدا نشد | ضربه آزاد', path: `/competition/${id}` });
        }

        // با عوض شدن لیگ، اخبار تب «اخبار» باید مالِ همین لیگ تازه لود شوند
        // (وگرنه اخبار لیگ قبلی باقی می‌ماند و همهٔ لیگ‌ها یک لیست می‌بینند)
        this.newsLoaded = false;
        this.news = [];

        // دریافت لیست فصل‌های این لیگ
        const seasons = await this.$store.dispatch('fetchSeasons', id);

        if (seasons.length > 0) {
          // انتخاب آخرین فصل (اولین آیتم در آرایه معمولاً جدیدترین است)
          this.currentSeasonId = seasons[0].id;
          await this.loadData(this.currentSeasonId);
        } else {
          // اگر هیچ فصلی وجود نداشت
          this.table = [];
          this.currentSeasonId = null;
        }

        // اگر همین الان روی تب اخبار هستیم، اخبار لیگ تازه را بگیر
        if (this.activeTab === 'news') {
          await this.ensureTabData('news');
        }
      } catch (e) {
        console.error(e);
      }
    },

    async loadData(seasonId) {
      const competitionId = this.competition.id;

      // دریافت جدول با competitionId و seasonId
      this.table = await this.$store.dispatch('fetchStandings', {
        competitionId,
        seasonId
      });

      // جدول‌های گروهی (مثل شرق/غرب آسیا) — اگر چند جدول باشد سوییچر نشان داده می‌شود
      try {
        const groups = await api.request(`/competition/${competitionId}/table-groups?seasonId=${seasonId}`);
        const list = (Array.isArray(groups) ? groups : []).filter(g => g && Array.isArray(g.rows) && g.rows.length);
        if (list.length > 1) {
          this.tableGroups = list;
          if (!list.some(g => g.name === this.activeGroup)) {
            this.activeGroup = list[0].name;
          }
          const sel = list.find(g => g.name === this.activeGroup);
          this.table = sel.rows;
        } else {
          this.tableGroups = [];
          this.activeGroup = null;
        }
      } catch (e) {
        this.tableGroups = [];
        this.activeGroup = null;
      }

      // با تغییر فصل، دادهٔ تب‌های وابسته به فصل باید تازه شود
      this.matchesLoaded = false;
      this.matches = [];

      if (this.activeTab === 'matches' || this.activeTab === 'stats') {
        await this.ensureTabData(this.activeTab);
      }
    },

    // دادهٔ هر تب فقط اولین بار (و بعد از تغییر فصل) لود می‌شود
    async ensureTabData(tab) {

      if (!this.competition) return;

      // مسابقات و آمار هر دو به لیست بازی‌های فصل نیاز دارند
      if ((tab === 'matches' || tab === 'stats') && !this.matchesLoaded) {
        try {
          this.matches = await competitionService.matches(
              this.competition.id,
              this.currentSeasonId
          ) || [];
        } catch (e) {
          console.error('loadMatches:', e);
          this.matches = [];
        }
        this.matchesLoaded = true;
      }

      if (tab === 'news' && !this.newsLoaded) {
        try {
          const res = await api.request(
              `/news?competitionId=${this.competition.id}&limit=12&page=1`
          );
          this.news = res?.news || [];
        } catch (e) {
          console.error('loadNews:', e);
          this.news = [];
        }
        this.newsLoaded = true;
      }

    },

    async onSeasonChange(seasonId) {
      this.currentSeasonId = seasonId;
      await this.loadData(seasonId);
    },

    // سوییچ بین جدول‌های گروهی (شرق/غرب آسیا)
    selectGroup(name) {
      if (this.activeGroup === name) return;
      this.activeGroup = name;
      const g = this.tableGroups.find(x => x.name === name);
      if (g) this.table = g.rows;
    }
  }

}

</script>

<style scoped>

.competition-page {

  max-width: 1400px;

  margin: auto;

  padding: 24px;

  .top-table {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

/* تبلت/لپ‌تاپ کوچک (769–1024) — تب‌ها و سوییچر فصل پشت‌سرهم
   تا ردیف فضایی‌بین با فاصلهٔ خالی عجیب وسط صفحه نسازد */
@media (max-width: 1024px) {

  .competition-page {
    padding: 16px 14px;
  }

  /* ✅ specificity برابر انتخاب تودرتو — وگرنه align-items اعمال نمی‌شود */
  .competition-page .top-table {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

}

/* موبایل: تب‌ها + سلکت فصل در «یک خط» — تب‌ها فضا را می‌گیرند، سلکت جمع‌وجور می‌ماند */
@media (max-width: 768px) {

  .competition-page {
    padding: 14px 12px;
  }

  .top-table {
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    gap: 8px;
  }

  .top-table > .competition-tabs {
    flex: 1 1 auto;
    min-width: 0;
    margin-bottom: 0;
  }

  .top-table > .season-switcher {
    flex: 0 0 auto;
    margin: 0;
  }

  .top-table > .season-switcher ::v-deep label {
    display: none; /* فقط خود سلکت — تا در یک خط جا شود */
  }

  .top-table > .season-switcher ::v-deep select {
    min-width: 0;
    width: 108px;
    padding: 8px 8px;
    font-size: 13px;
  }

}

/* سوییچر جدول‌های گروهی (شرق/غرب آسیا) */
.table-group-switch {
  display: flex;
  gap: 8px;
  margin-bottom: 14px;
}

.group-chip {
  padding: 7px 18px;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  background: #fff;
  color: #64748b;
  font-family: inherit;
  font-size: 0.82rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
}

.group-chip:hover {
  border-color: #2563eb;
  color: #2563eb;
}

.group-chip.active {
  background: #0f172a;
  border-color: #0f172a;
  color: #fff;
}

</style>